import { GetColorRulesResponse } from "@/app/api/color-rules/route";
import { getColorRulesRequestSchema } from "@/lib/schemas/color-rules";
import { createInvalidateQuery, createQueryHook } from "@/lib/queries";

const COLOR_RULES_ENDPOINT = "/api/color-rules";

export const invalidateColorRulesQuery =
  createInvalidateQuery(COLOR_RULES_ENDPOINT);

export const useColorRulesQuery = createQueryHook<GetColorRulesResponse>(
  COLOR_RULES_ENDPOINT,
  getColorRulesRequestSchema,
);
